/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import Map from 'scripts/models/base/map';
import FeedService from 'scripts/services/base-feed-service';
import RouteCreator from 'scripts/services/route-creator';
import template from './drawer-mini.stache';

const playerFeedUrl = window.globalSettings.feeds.smt.playerUrl;

Component.extend({
    tag: 'leaderboard-drawer-mini',
    template: template,
    viewModel: {
        define: {
            activeId: {
                type: 'string',
                value: '',
            },
            fetching: {
                type: 'boolean',
                value: true,
            },
            data: {
                Type: Map,
                Value: Map,
            },
            player: {
                Type: Map,
                Value: Map,
            },
            playerPagePath: {
                get() {
                    const playerId = this.attr('data.player.identifier');
                    return RouteCreator.playerDetail(playerId);
                },
            },
            playerFullVideoRecapPath: {
                get() {
                    const isRecapAvailable = this.attr(
                        'data.data.isRecapAvailable',
                    );
                    const playerId = this.attr('data.player.identifier');
                    if (isRecapAvailable) {
                        return RouteCreator.playerFullVideoRecap(playerId);
                    }
                    return null;
                },
            },
            visible: {
                get() {
                    let activeId = this.attr('activeId');
                    return activeId == this.data.player.identifier;
                },
            },
        },
    },
    events: {
        inserted() {
            if (this.viewModel.attr('visible')) {
                this.loadPlayerData();
            }
        },
        removed() {
            if (this.playerFeedService) {
                this.playerFeedService.destroy();
            }
        },
        '{scope} visible'() {
            this.loadPlayerData();
        },
        loadPlayerData() {
            let identifier = this.viewModel.data.player.identifier;

            if (identifier && !this.playerFeedService) {
                this.playerFeedService = new FeedService(playerFeedUrl, false);
                this.playerFeedService.on('data', (ev, data) => {
                    this.viewModel.attr('fetching', false);
                    this.viewModel.attr('player', data);
                });

                this.playerFeedService.fetch({ identifier });
            }
        },
    },
});
